import { DynamicPositionFilters } from "./Positions/DynamicPositionFilters";
import { SideHeader } from "./SideHeader";

export type LeftHandMenuProps = {
    mobileOnly: boolean
}

export function LeftHandMenu(props: LeftHandMenuProps) {
    return (
        <div className={`row ${props.mobileOnly ? "mob-only" : ""}`}>
            <div className="col-12">
                {/* This will contain the quick filters */}

                <div className="offcanvas-lg offcanvas-start" tabIndex={-1} id="lhmSidebar" aria-labelledby="lhmSidebarOffcanvasLabel">
                    {/* LHM Sidebar */}
                    <div className="offcanvas-header bg-primary">
                        <button type="button" id="close-lefthand-menu" className="btn btn-nav-close ms-0" data-bs-dismiss="offcanvas" aria-label="Close" data-bs-target="#lhmSidebar"><i className="fa-solid fa-x"></i></button>
                    </div>

                    <div className="offcanvas-body p-0">
                        <nav className="w-100" id="pos-nav" aria-label="Docs navigation"><ul className="list-unstyled mb-0 pb-3">
                            <SideHeader mobileOnly={true} name={"Quick filters"} />
                            <li className="py-2">
                                <DynamicPositionFilters redirectToPositionList={props.mobileOnly} />
                            </li>
                        </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    );
}